
export default function EmergencyDentalCare() {
  return (
    <section className="py-20 px-4 sm:px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-[#444c42] mb-6">
            Emergency Dental Care
          </h2>
          <h3 className="text-2xl md:text-3xl font-semibold text-[#d0a24f] mb-8">
            Book an emergency dentist appointment today
          </h3>
        </div>

        <div className="max-w-4xl mx-auto bg-gradient-to-br from-[#f8f9fa] to-white rounded-3xl p-8 md:p-12 shadow-xl border border-gray-100">
          <div className="space-y-6 text-center">
            <div className="flex justify-center mb-6">
              <div className="w-20 h-20 flex items-center justify-center bg-red-600 rounded-full">
                <i className="ri-alarm-warning-line text-4xl text-white"></i>
              </div>
            </div>

            <p className="text-lg text-[#444c42] leading-relaxed">
              We offer emergency care, subject to availability – <strong className="text-red-600">CALL OUT FEES APPLY</strong>.
            </p>

            <p className="text-lg text-[#444c42] leading-relaxed">
              If you think you need an emergency dentist in Chelmsford, please call us on <a href="tel:01245465586" className="font-bold text-[#d0a24f] hover:text-[#444c42] transition-colors cursor-pointer">01245 465586</a>, and a member of our team will get back to you shortly. Calling us directly will allow us to assist with your emergency appointment asap.
            </p>

            <p className="text-lg text-[#444c42] leading-relaxed">
              You can still access our emergency dentist appointments even if you are not registered with our practice.
            </p>

            <div className="pt-6">
              <a
                href="tel:01245465586"
                className="inline-flex items-center gap-3 bg-red-600 text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-red-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-2xl"></i>
                Call Now: 01245 465586
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm text-[#7A8178] max-w-2xl mx-auto leading-relaxed">
            Our experienced team is here to help you with dental emergencies. We understand that dental pain can be distressing, and we'll do our best to see you as quickly as possible.
          </p>
        </div>
      </div>
    </section>
  );
}
